import { render } from "./SimpleList.vue?vue&type=template&id=0aab71be"
import script from "./SimpleList.vue?vue&type=script&lang=js"
export * from "./SimpleList.vue?vue&type=script&lang=js"
script.render = render

export default script